"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "terni": {
    "bcba009c": [{
      "hkey": "05ce24c2",
      "slug": "gabelletta",
      "name": "Gabelletta",
      "primary": true,
      "skipSearch": false
    }],
    "gabeletta": [{
      "hkey": "05ce24c2",
      "slug": "gabelletta",
      "name": "Gabelletta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d15c6ed1": [{
      "hkey": "1a34e3d6",
      "slug": "poggio-lavarino",
      "name": "Poggio Lavarino",
      "primary": true,
      "skipSearch": false
    }],
    "lavarino": [{
      "hkey": "1a34e3d6",
      "slug": "poggio-lavarino",
      "name": "Poggio Lavarino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6f2ece82": [{
      "hkey": "3eaada81",
      "slug": "terni",
      "name": "Terni",
      "primary": true,
      "skipSearch": false
    }],
    "poggio": [{
      "hkey": "3eaada81",
      "slug": "terni",
      "name": "Terni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea005bec": [{
      "hkey": "7ba358d8",
      "slug": "borgo-rivo",
      "name": "Borgo Rivo",
      "primary": true,
      "skipSearch": false
    }],
    "rivo": [{
      "hkey": "7ba358d8",
      "slug": "borgo-rivo",
      "name": "Borgo Rivo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a471793": [{
      "hkey": "41113ae9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "41113ae9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "terni"
    }],
    "b4977b90": [{
      "hkey": "4ccf4938",
      "slug": "cesure-san-rocco-valenza",
      "name": "Cesure-San Rocco-Valenza",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "cfa9f66f",
      "slug": "battisti-cardeto",
      "name": "Battisti-Cardeto",
      "primary": true,
      "skipSearch": false
    }],
    "semiperiferia-periferia": [{
      "hkey": "cfa9f66f",
      "slug": "battisti-cardeto",
      "name": "Battisti-Cardeto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "terni"
    }],
    "918f6280": [{
      "hkey": "4ccf4938",
      "slug": "cesure-san-rocco-valenza",
      "name": "Cesure-San Rocco-Valenza",
      "primary": true,
      "skipSearch": false
    }],
    "valenza": [{
      "hkey": "4ccf4938",
      "slug": "cesure-san-rocco-valenza",
      "name": "Cesure-San Rocco-Valenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65ccbc88": [{
      "hkey": "3eaada81",
      "slug": "terni",
      "name": "Terni",
      "primary": true,
      "skipSearch": false
    }],
    "zona-agricola": [{
      "hkey": "3eaada81",
      "slug": "terni",
      "name": "Terni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;